import {createSlice} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import Team from '../../api/team'
import {setConfirmIsActive} from '../alert'
import FormHelper from '../../utils/forms'

export const membersSlice = createSlice({
    name: 'members',
    initialState: {
        members: [],
        isMembersLoading: false
    },
    reducers: {
        setMembers: (state, {payload}) => {
            state.members = payload
        },
        setIsMembersLoading: (state, {payload}) => {
            state.isMembersLoading = payload
        }
    }
})

export const {
    setMembers,
    setIsMembersLoading
} = membersSlice.actions

export default membersSlice.reducer

export const getActiveMembers = (teamId, showLoader = false) => {
    return async dispatch => {
        showLoader && dispatch(setIsMembersLoading(true))
        try {
            const {data} = await Team.getActiveTeamMembers(teamId)
            dispatch(setMembers(data?.data?.team_members))
        } catch (e) {
            toast.error(e?.response?.data?.message)
        }
        showLoader && dispatch(setIsMembersLoading(false))
    }
}

export const getAllActiveMembers = (teams) => {
    return async() => {
        try {
            const promises = teams?.map(team => {
                return Team.getActiveTeamMembers(team?.team_id)
            })
            const res = await Promise.all(promises)
            const members = res?.filter(item => item?.data?.data).map((item, index) => {
                return item?.data?.data?.team_members?.map(member => {
                    return {
                        ...member,
                        label: `${member?.name} ${member?.surname} (${teams?.[index]?.name})`,
                        value: member?.customer_id,
                        team_id: teams?.[index]?.team_id
                    }
                })
            })
            return members?.reduce((accumulator, currentArray) => {
                return accumulator.concat(currentArray)
            }, [])
        } catch (e) {
            toast.error(e?.response?.data?.message)
        }
    }
}

export const getInvitationsMembers = (teamId) => {
    return async() => {
        try {
            const {data} = await Team.getInvitationsMembers(teamId)
            return data?.data?.invitations || {
                message: data?.message
            }
        } catch (e) {
            toast.error(e?.response?.data?.message)
        }
    }
}

export const addTeamMember = (teamId, values, setFieldError) => {
    return async() => {
        try {
            const {data} = await Team.addTeamMember(teamId, values)
            toast.success(data?.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}

export const deleteMember = (teamId, id, type) => {
    return async dispatch => {
        try {
            let res
            if (type === 'active') {
                res = await Team.deleteTeamMember(teamId, id)
            } else {
                res = await Team.deleteInvitation(teamId, {
                    channel_value: id
                })
            }
            dispatch(setConfirmIsActive(false))
            toast.success(res?.data?.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message)
        }
    }
}

export const remindMember = (teamId, channel) => {
    return async() => {
        try {
            const {data} = await Team.remindTeamMember(teamId, {
                channel_value: channel
            })
            toast.success(data?.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message)
        }
    }
}

export const updateTeamMember = (teamId, id, values, setFieldError) => {
    return async() => {
        try {
            const {data} = await Team.updateTeamMember(teamId, id, values)
            toast.success(data?.message)
            return true
        } catch (e) {
            const res = e?.response?.data
            const fields = res?.data?.fields
            const message = res?.message
            FormHelper.setFormElementError(fields, message, setFieldError)
        }
    }
}
